// Imports
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(function(i){return i[1]});
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".src-SkinTrack-Detail-Note__notes--fmdl1 h3{margin-top:0}.src-SkinTrack-Detail-Note__note--3Kk0x{font-family:\"Courier\",serif;font-size:1em;white-space:pre-line;max-height:190px;overflow:auto}.src-SkinTrack-Detail-Note__hidden--jurAK{display:none}.src-SkinTrack-Detail-Note__inputNote--t9Tv7{font-family:\"Courier\",serif;font-size:1em;width:100%;height:190px;border:none}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"notes": "src-SkinTrack-Detail-Note__notes--fmdl1",
	"note": "src-SkinTrack-Detail-Note__note--3Kk0x",
	"hidden": "src-SkinTrack-Detail-Note__hidden--jurAK",
	"inputNote": "src-SkinTrack-Detail-Note__inputNote--t9Tv7"
};
export default ___CSS_LOADER_EXPORT___;
